// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"_38nbCl","spinner":"_26a3Eh","content":"ZIn_V-","isLoading":"_1_aPyA"};